import { useQuery } from '@tanstack/react-query';
import { ObjectOwner, PaginatedObjectsResponse } from '@mysten/sui.js/client';
import { useSuiClient } from '@mysten/dapp-kit';
import { TANSTACK_OWNED_POINTS_KEY } from '../utils/constants';
import { IConsts } from 'sudo-ts-sdk';
import { parseObjectFields } from '../utils/utils';

export function useSudoCardPoints({
  consts,
  address,
  cursor = undefined,
  limit = 50,
}: {
  consts: IConsts;
  address?: string;
  cursor?: string;
  limit?: number;
}) {
  const provider = useSuiClient();

  return useQuery({
    queryKey: [TANSTACK_OWNED_POINTS_KEY, address, cursor],
    queryFn: async () => {
      if (!address) return [];

      let objectsData: any[] = [];
      let queryNextPage = true;
      let queryCursor = cursor;

      while (queryNextPage) {
        const { data, hasNextPage, nextCursor }: PaginatedObjectsResponse =
          await provider.getOwnedObjects({
            owner: address,
            filter: {
              StructType: `${consts.sudoNft.package}::card::Points`,
            },
            options: {
              showType: true,
              showContent: true,
              showOwner: true,
              showPreviousTransaction: true,
            },
            cursor: queryCursor,
            limit,
          });

        queryNextPage = hasNextPage;
        queryCursor = nextCursor!;
        if (!data) break;
        objectsData = [...objectsData, ...data];
      }

      const fields = parseObjectFields(objectsData);

      const mappedData = objectsData.map(item => ({
        type: item.data?.type || '',
        kioskId: '',
        isLocked: true,
        objectId: item.data?.objectId || '',
        owner: (item.data?.owner as ObjectOwner) || '',
        fields: fields[item.data?.objectId!],
        previousTransaction: item.data?.previousTransaction || '',
        display: {},
      }));

      return mappedData;
    },
  });
}
